import { HttpState } from ".";

export default {
    setStatus(state:HttpState, status:number) {
        state.status = status;
    }
}